import { useQuery } from '@src/shared/query';
import type { UseQueryParams } from '@src/features/types';
import { resourceUserFromDto } from '../../lib';
import type { ResourceUser, ResourceUserDto } from '../../types';
import { absToolResourcesUrl } from './constants';

export default function useResourceUsers(params: Partial<UseQueryParams> = {}) {
  const { queryParams = {} } = params;
  const query = useQuery<ResourceUserDto[], ResourceUser[]>(
    absToolResourcesUrl,
    {
      queryParams,
      select: (data: Array<ResourceUserDto>) => data.map(resourceUserFromDto),
      initialData: [],
    },
  );

  const { data: users = [], ...restQuery } = query;
  return {
    users,
    ...restQuery,
  };
}
